<template>
  <div class="login-full">
    <!-- <img class="img" src="./assets/blbS-hnfikve4966022.jpg" alt=""> -->
    <img class="img" src="https://img0.baidu.com/it/u=3220675334,4066749862&fm=253&fmt=auto&app=138&f=JPEG?w=889&h=500" alt="">
    <div class="login-modal">
      <!-- <div class="register" @click="loginRegisterChange">{{ text }}</div> -->
      <div class="title">用户登录</div>
      <div>
        <span class="label">用户名：</span><input placeholder="请输入用户名" v-model="username" type="text">
      </div>
      <div>
        <span class="label">密码：</span><input placeholder="请输入密码" v-model="password" type="password">
      </div>
      <div v-if="!flag">
        <span class="label">确认密码：</span><input placeholder="请输入密码" v-model="password1" type="password">
      </div>
      <!-- <div>
        <span class="label">身份：</span>
        <template>
  <el-radio v-model="types" label="1">求助者</el-radio>
  <el-radio v-model="types" label="2">志愿者</el-radio>
  <el-radio v-model="types" label="3">管理员</el-radio>
</template>

      </div> -->
      <div class="login">
        <button v-if="flag" class="button" @click="login">立即登录</button>
        <button v-else class="button button2" @click="register">立即注册</button>
      </div>
    </div>
  </div>
</template>

<script>
import { register ,login} from './api/user/user'
import { Notification, MessageBox, Message } from "element-ui";
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data () {
    return {
      text: '注册',
      flag: true,  //  登录
      username: '',       //  用户名
      password: '',     // 密码
      password1:'', //   重复密码
      types:'1',   // 用户类型
    }
  },
  
  methods: {

    // 登录接口
    login () {
      debugger
      if (!this.username) {
        return Message({
          message: '请输入用户名',
          type: "error",
          duration: 5 * 1000
        });
      }
      if (!this.password) {
        return Message({
          message: '请输入密码',
          type: "error",
          duration: 5 * 1000
        });
      }
      let params = {
        username:this.username,
        password:this.password,
      }
      login(params).then(res=>{
        debugger
       if(res.code == '200'){
        Message({
          message: '登录成功',
          type: "success",
          duration: 5 * 1000
        });
        debugger
        console.log(res.data.token)
        localStorage.setItem('userInfo',JSON.stringify(res.data.user))
        console.log(localStorage.getItem('userInfo'))
        localStorage.setItem('token',res.data.token)
        this.$router.push('/infoManage')
       }else{
        Message({
          message: '用户名/密码错误',
          type: "error",
          duration: 5 * 1000
        });
       }
  
      })
    },
    //  登录注册切换
    loginRegisterChange () {
      this.flag = !this.flag
      if (this.flag) {
        this.text = '注册'
      } else {
        this.text = '返回登录'
      }
    },
    // 注册接口
    register () {
      
      if (!this.username) {
        return Message({
          message: '请输入用户名',
          type: "error",
          duration: 5 * 1000
        });
      }
      if (!this.password) {
        return Message({
          message: '请输入密码',
          type: "error",
          duration: 5 * 1000
        });
      }
      if (this.password != this.password1) {
        return Message({
          message: '两次密码不一致',
          type: "error",
          duration: 5 * 1000
        });
      }
      let params = {
        username:this.username,
        password:this.password,
        types:this.types,
      }
      register(params).then(res => {
        debugger
        this.loginRegisterChange()
        return Message({
          message: res.data,
          type: "success",
          duration: 5 * 1000
        });
       
      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-full {
  /* position: absolute;
  top: 0;
  left: 0;
  width: 100%;  
  height: 100%; */
}

.register {
  text-align: right;
  margin-right: 20px;
  color: blue;
}

.img {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  position: fixed;
  left: 0;
  bottom: 0;
}

.login-modal {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 400px;
  height: 300px;
  transform: translate(-50%, -50%);
  background-color: white;
  z-index: 1000;
  border-radius: 20px;
  padding-top: 10px;
  box-sizing: border-box;
}

.label {
  width: 80px;
  display: inline-block;
  text-align: right;
  margin-top: 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.login {
  margin-top: 40px;
}

.button {
  width: 200px;
  background-color: green;
  color: white;
  border: none;
  padding: 10px 0;
}

.button2 {
  background-color: rgb(21, 120, 234);
}</style>



// WEBPACK FOOTER //
// src/login.vue